import * as Sentry from '@sentry/browser';
import { captureMessage } from './utils';
import env from '../env';
export const sentryFetchHandler = result => {
  if (env.REACT_APP_SENTRY_ENABLED === 'true') {
    Sentry.withScope(scope => {
      const transactionName = `${result?.request?.method} ${result?.request?.url}`;
      scope.setTransactionName(transactionName);
      const errorMessage = result?.error?.message || result?.error?.errors?.[0] || `${result.status} on ${transactionName}`;
      captureMessage(`Request error: ${errorMessage}`, {
        level: 'error',
        fingerprint: ['{{ default }}'],
        contexts: {
          RequestError: {
            ...result?.error,
            httpStatus: result?.status,
            method: result?.request?.method,
            corrId: result?.request?.headers?.get('X-CF-CORR-ID')
          }
        }
      });
    });
  }
};